import ImportExport from './ImportExport'
import ImportExportHeader from './ImportExportHeader'
import ImportExportHelp from './ImportExportHelp'

export default {
  default: ImportExport,
  header: ImportExportHeader,
  help: ImportExportHelp,
}
